export default "__VITE_ASSET__DhjF5ycc__"